// Shared setup for on/off visitor preferences (e.g. reduced motion),
// each a class on <html>. That class is rendered server-side from the
// preference's cookie (see common.context_processors.preferences) or, when
// there's no valid cookie, from the device setting by
// templates/partials/preferences_head.html. The cookie is only written once
// the visitor picks a setting here, so until then the site keeps following
// their device.

import Cookies from 'js-cookie'

export const COOKIE_OPTIONS = { expires: 365, sameSite: 'Lax' }
const ROOT = document.documentElement

// Clears the cookie from the removed dark mode toggle. Delete this line once
// those have expired (they lasted a year), i.e. from November 2027.
Cookies.remove('darkmode')

// Reads the class rather than the media query, so a visitor who turned
// reduced motion off on the site gets motion despite their device setting.
export const prefersReducedMotion = () =>
    ROOT.classList.contains('reduce-motion')

// For scrollTo/scrollIntoView's `behavior`
export const scrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth')

/**
 * Wires up every button matching `selector` to toggle `className` on <html>,
 * saving the choice to `cookieName` and keeping each button's aria-pressed
 * in sync.
 */
export const setupPreferenceToggle = ({ cookieName, className, selector }) => {
    const buttons = document.querySelectorAll(selector)

    const syncButtons = () => {
        const enabled = ROOT.classList.contains(className)
        buttons.forEach((button) =>
            button.setAttribute('aria-pressed', enabled)
        )
    }

    const setEnabled = (enabled) => {
        ROOT.classList.toggle(className, enabled)
        Cookies.set(cookieName, String(enabled), COOKIE_OPTIONS)
        syncButtons()
        // Lets JS-drawn UI (e.g. the charts' canvases) follow the change
        document.dispatchEvent(new CustomEvent('preferencechange'))
    }

    // The server can't know the state when it came from the device setting
    // (no or invalid cookie), so read it back from the class the head
    // script applied.
    syncButtons()

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            setEnabled(!ROOT.classList.contains(className))
        })
    })
}
